import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import leagues from './modules/league'
import pools from './modules/pool'
import axios from '../axios'

Vue.use(Vuex)

const store = new Vuex.Store({
	modules: {
		auth,
		leagues,
		pools,
	},
	state: {
		httpInProgress: false
	},
	getters: {
		httpInProgress: state => {
			return state.httpInProgress;
		}
	},
	mutations: {
		HTTP_IN_PROGRESS: state => {
			state.httpInProgress = true	
		},
		HTTP_FINISHED: state => {
			state.httpInProgress = false
		}
	}
})

store.subscribe((mutation) => {
	switch(mutation.type) {
		case 'SET_TOKEN':
			if(mutation.payload) {
				axios.defaults.headers.common['Authorization'] = 'Bearer ' + mutation.payload
				//localStorage.setItem('token', mutation.payload)
			} else {
				axios.defaults.headers.common['Authorization'] = null
				//localStorage.removeItem('token', mutation.payload)
			}
			break;
	}
})

export default store
